import { useAuth } from 'react-oidc-context';
import Tabs from '../components/Tabs';
import { TabItem } from '../interface/interface';
import DeactivateRequestPatientList from './DeactivateRequestPatientList';
import Patients from './Patient';
import PatientPrescriptionDeleteRequest from './PrescriptionDeleteRequest';
import OnboardPatients from './OnboardPatients';
import { useContext } from 'react';
import { UserContext } from '../context/userContext';
import BulkEmailNotification from './BulkEmailNotification';

const PatientTabs = () => {
  const { user } = useAuth();
  const { requestPending } = useContext(UserContext);

  const tabs: TabItem[] = [];

  if (
    (user?.profile.groups as string[]).includes('Admin') ||
    (user?.profile.groups as string[]).includes('PLO')
  ) {
    tabs.push({ id: 'tab1', label: 'Patients', component: <Patients /> });
    tabs.push({
      id: 'tab2',
      label: 'Deactivation Requests',
      component: <DeactivateRequestPatientList />,
      indicator: requestPending.patientDeactivateRequested,
    });
    tabs.push({
      id: 'tab3',
      label: 'Manage Script Requests',
      component: <PatientPrescriptionDeleteRequest />,
    });
    tabs.push({ id: 'tab4', label: 'Onboard', component: <OnboardPatients /> });
    tabs.push({
      id: 'tab5',
      label: 'Bulk Email',
      component: <BulkEmailNotification />,
    });
  } else {
    tabs.push({ id: 'tab1', label: 'Patients', component: <Patients /> });
  }
  return <Tabs tabs={tabs} />;
};

export default PatientTabs;
